import { Component, Input, ElementRef, AfterViewInit, ChangeDetectorRef, Renderer2,
         ViewChild, NgZone, OnDestroy, HostListener, EventEmitter, Output } from '@angular/core';
import { Dialog } from '../../primeng_components/dialog/dialog';
// import { DomHandler } from 'primeng/primeng';
import { DomHandler } from '../../primeng_components/dom/domhandler';
import { DomSanitizer } from '@angular/platform-browser';
import { AppUtility } from '../../utils/utility';
import { DomStorageFallbackService } from '../../services/DomStorageFallback.service';

@Component({
    selector: 'al-dialog',
    templateUrl: './al-dialog.component.html',
    providers: [DomHandler]
})
export class AlDialogComponent extends Dialog implements AfterViewInit, OnDestroy {
    [x: string]: any;

    public dialogParentEle: HTMLElement;
    public dialogEle: HTMLElement;
    public focusedElBeforeOpenDialog: Element;
    public focusableEls: any;
    public config: any;
    public feedbackUrl: string;
    public prevUrl: string = document.referrer;
    public assignWidth: any;
    public bodyOverflow = '';
    public bodyHeight = '';
    public _url: string;
    public _isVideo = false;
    public _isBPOLightBox = false;
    @Input() visible: boolean;
    @Input() title: string;
    @Input() printLabel = 'Print';
    @Input() feedbackLabel = 'Feedback';
    @Input() printLinkTitle = 'Choose this link to print this dialog.';
    @Input() feedbackLinkTitle = 'Choose this link to give feedback on this page.';
    @Input() closeLinkTitle = 'Click this link to close dialog.';
    @Input() beginOfDialogText = 'Start of dialog modal content.';
    @Input() endOfDialogText = 'End of dialog modal content.';
    @Input() copyright = 'Â©2017-2018 Alight Solutions';
    @Input() url: string;
    @Input() display: boolean;
    @Input() showFooter: boolean;
    @Input() showModal = false;
    @Input() showHeader = false;
    @Input() resizable = false;
    @Input() draggable = false;
    @Input() showPrint: boolean;
    @Input() showFeedback: boolean;
    @Input() showIframe: boolean;
    @Input() locale = 'en_US';
    @Input() lifecyclePhase = 'test';
    @Input() friendlyPageName = 'Home';
    @Input() pageName = 'Home Page';
    @Input() clientId = '19920';
    @Input() subCategory = 'Admin';
    @Input() category = 'Portal Foundation';
    @Input() portalVersion = '2.0_2.0_2.0';
    @Input() version = '2222.7878';
    @Input() baseClientIndicator = 'Base';
    @Input() isQualtricsFeedbackEnabled = true;
    @Input() minWidth = 150;
    @Input() minHeight = 150;
    @Input() width: any;
    @Input() height: any;
    @Input() closable = false;
    @Input() styleClass: string;
    @Input() closeIcon: boolean = true;
    @Output() onHide = new EventEmitter();

    /**
     * Setting reference variable on nativeElement to get an ElementRef
     */
    @ViewChild('container', {static: false}) containerViewChild: ElementRef;

    constructor(private _element: ElementRef, private cdr: ChangeDetectorRef,
                domHandler: DomHandler, renderer: Renderer2,
                public sanitizer: DomSanitizer, private appUtility: AppUtility,
                zone: NgZone) {
        super(_element, domHandler, renderer, zone);
    }

    /**
     * Checking dialog view is initialized or not
     * make header visible if print and feedback link set as a true
     *
     * @event ngAfterViewInit
     */
    ngAfterViewInit() {
        if (this.showPrint || this.showFeedback || this.title || this.url) {
            this.showHeader = true;
        }
        this.dialogEle = this._element.nativeElement;
        this.dialogParentEle = this.dialogEle.parentElement;
        this.cdr.detectChanges();
    }

    /**
     * Checking if, dialog instance is available remove the same on route change
     *
     * @event ngOnDestroy
     */
    ngOnDestroy() {
        // document.body.removeChild(this.dialogEle);
    }

    /**
     * @HostListener
     * Setting hostlistener on window resize event for width adjustment of flyout
     *
     */
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setDialogStyle();
    }

    setDialogStyle() {
        setTimeout(() => {
            const uiDialogElem = this._element.nativeElement.querySelector('.ui-dialog');
            /* uiDialogElem.style.left = '50%';
            uiDialogElem.style.top = '50%'; */
            if (uiDialogElem) {
                if (parseInt(this.assignWidth, 10) > window.innerWidth) {
                    uiDialogElem.style.width = '93%';
                } else {
                    uiDialogElem.style.width = this.assignWidth;
                }
            }
        }, 66);
    }

    /**
     * show dialog element and bind bindGlobalListeners once dialog is visible
     *
     * @method showDialog
     */
    showDialog(event?) {
        this.display = true;
        this._isVideo = false;
        this._isBPOLightBox = false;
        const uiDialogElem = this._element.nativeElement.querySelector('.ui-dialog');
        const widgetOverlay = this._element.nativeElement.querySelector('.ui-widget-overlay');
        this.checkBPOLightBox(event);

        if (uiDialogElem) {
            uiDialogElem.style.width = this.width;
            uiDialogElem.style.height = this.height;
            this.assignWidth = uiDialogElem.style.width;
            if (this.url) {
                this._url = this.url;
            }

            if (this._url && (this._url.indexOf('/video?videoId=') !== -1 || this._url.indexOf('cloudcmsvideocontent') !== -1)) {
                this._isVideo = true;
                let uiDialogContent = this._element.nativeElement.querySelector('.ui-dialog .ui-dialog-content');
                uiDialogContent.classList.add('ui-dialog-content-autoheight');
            }
        }

        if (widgetOverlay) {
            this.appUtility.setAttributes(widgetOverlay, {
                'aria-hidden': 'false',
                'role': 'dialog',
                'tabindex': '0'
            });

            if (this.title) {
                this.appUtility.setAttributes(widgetOverlay, {
                    'aria-labelledby': 'dialogheader'
                });
            }
        }

        // setTimeout(() => {
        //     this.assignWidth = this._element.nativeElement.querySelector('.ui-dialog').style.width;
        // }, 0);
        this.setDialogStyle();
        document.body.insertBefore(this.dialogEle, document.body.firstChild);
        widgetOverlay.classList.remove('hidden');
        if (event) {
            this.focusedElBeforeOpenDialog = event.currentTarget || event.originalTarget;
        }
        this.bindGlobalListeners();
        this.bodyOverflow = document.querySelector('body').style.overflow;
        this.bodyHeight = document.querySelector('body').style.height;
        document.querySelector('body').style.overflow = 'hidden';
        document.querySelector('body').style.height = '100vh';
    }

    /**
     * Hide dialog element and set focus on trigger element
     *
     * @method hideDialog
     */
    hideDialog(event) {
        this.display = false;
        const widgetOverlay = this._element.nativeElement.querySelector('.ui-widget-overlay');

        if (this.dialogParentEle) {
            // this.dialogParentEle.appendChild(this.dialogEle);
            if (this.dialogEle) {
                if (this.dialogEle.parentNode) {
                    this.dialogEle.parentNode.removeChild(this.dialogEle);
                }
            }
        }

        if (this.dialogEle) {
            this.dialogEle.setAttribute('aria-hidden', 'true');
        }
        this.appUtility.setAttributes(widgetOverlay, {
            'aria-hidden': 'true',
            'role': 'dialog',
            'tabindex': '-1'
        });

        widgetOverlay.classList.add('hidden');

        try {
            if ((this.focusedElBeforeOpenDialog as HTMLElement)) {
                (this.focusedElBeforeOpenDialog as HTMLElement).focus();
            }

        } catch (error) {
        }
        // this.cdr.detectChanges();
        document.querySelector('body').style.overflow = this.bodyOverflow;
        document.querySelector('body').style.height = this.bodyHeight;
        this.onHide.emit(event);
        // return true;
    }

    /**
     * Bind close event on dialog box
     *
     * @method close
     */
    close(event: Event) {
        this.hideDialog(event);
    }

    /**
     * Bind global lister once dialog is visible
     *
     * @method bindGlobalListeners
     */
    bindGlobalListeners() {
        if (this.closeOnEscape) {
            this.bindDocumentEscapeListener();
        }
    }

    /**
     * Binding escape lister to document for closing dialog
     *
     * @method bindDocumentEscapeListener
     */
    bindDocumentEscapeListener() {
        this.documentEscapeListener = this.renderer.listen('document', 'keydown', (event) => {
            if (event.which === 27) {
                setTimeout(() => {
                    this.close(event);
                }, 10);
            }
        });

        /*
		this.documentEscapeListener = this.renderer.listen('document', 'mousedown', (event) => {
            let targetEle: any = event.target || event.srcElement;
            if (targetEle.classList.contains('fa-close')) {
                this.close(event);
            }
        });
		*/
    }

    /**
     * Calling feedback window if user hit on feedback link from dialog header
     *
     * @method feedbackWindow
     */
    feedbackWindow() {
        /* Added for AC04033 to get the locale */
        let domStorageFB = new DomStorageFallbackService();
        if (domStorageFB.getItem('lr_json_data') && JSON.parse(domStorageFB.getItem('lr_json_data')).locale) {
            this.locale = JSON.parse(domStorageFB.getItem('lr_json_data')).locale;
         } else if (domStorageFB.getItem('alightRequestHeader') && JSON.parse(domStorageFB.getItem('alightRequestHeader')).locale) {
             this.locale = JSON.parse(domStorageFB.getItem('alightRequestHeader')).locale;
         }
        if (this.isQualtricsFeedbackEnabled) {
            this.initializeQualtricsFeedbackUrl();
        } else {
            this.initializeFeedBackUrl();
        }
        window.open(this.feedbackUrl, 'feedbackSurvey',
                    'width=575, height=331, left=400, top=200, scrollbars=yes, menubar=no, toolbar=no, resizable=yes');
        this.cdr.detectChanges();
    }

    /**
     * Making dialog content pritable if user hit cltr + p/browser default print functionality
     * adding al-print-no class on rest of the dom
     * creating new div and injecting dialog content and adding al-print-pnly class
     *
     * @method printWindow
     */
    printWindow() {
        const lightbox_content = this._element.nativeElement.querySelector('.al-dialog-content');
        const allNode = document.querySelectorAll('body > *');
        // let arrays: string[];
        [].forEach.call(allNode, (ele) => {
            this.domHandler.addClass(ele, 'al-print-no');
        });

        const lightBoxPrintObj = document.createElement('div');

        /** Get HTML of Iframe on print button click */
        const element: HTMLIFrameElement = this._element.nativeElement.querySelector('iframe');
        if (lightbox_content) {
        if (lightbox_content.contains(element)) {
            const iframe = element.contentWindow;
            if (iframe !== null) {
                const iFrameInnetHtml = iframe.document.body.innerHTML;
                const printContent = '<div class="al-print-light-box al-print-only al-page-wrapper">' + iFrameInnetHtml + '</div>';
                lightBoxPrintObj.innerHTML = printContent;
                document.body.appendChild(lightBoxPrintObj);
            }
        } else {
            const printContent = '<div class="al-print-light-box al-print-only al-page-wrapper">' + lightbox_content.innerHTML + '</div>';
            lightBoxPrintObj.innerHTML = printContent;
            document.body.appendChild(lightBoxPrintObj);
        }
    }
        if (element) {
            if (element.contentWindow) {
                element.contentWindow.print();
            }
        } else {
            window.print();
        }

        const allNode1 = document.querySelectorAll('*');
        [].forEach.call(allNode1, (ele) => {
            this.domHandler.removeClass(ele, 'al-print-no');
        });

        const lightBoxEle = document.querySelectorAll('.al-print-light-box');
        [].forEach.call(lightBoxEle, (ele) => {
            ele.remove();
        });
    }

    /**
     * Making dialog accessible with keyboard for Accessibility
     * Preventing focus to jump outside of dialog while pressing tab key
     *
     * @method manageAccessibility
     *
     */
    manageAccessibility() {
        const focusableEls = this._element.nativeElement.querySelectorAll
        ('a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
        this.focusableEls = Array.prototype.slice.call(focusableEls);

        const firstElement = this.focusableEls[0];
        firstElement.focus();
        const getLength = this.focusableEls.length - 1;
        const lastElement = this.focusableEls[getLength];

        /* check last and first element of dialog is focusable or not */
        if (lastElement && firstElement) {

            /*redirect last tab to first input*/
            lastElement.addEventListener('keydown', (e) => {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstElement.focus();
                }
            });

            /*redirect first shift+tab to last input*/
            firstElement.addEventListener('keydown', (e) => {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastElement.focus();
                }
            });
        }
    }

    public getBaseDomain() {
        let baseDomain = '';

        const OPINION_LABS_TEST_DOMAIN = 'http://test.hewitt.hro';
        const OPINION_LABS_DOMAIN = 'http://resources.hewitt.com';
        const OPINION_LABS_TEST_DOMAIN_MOBILE = 'http://test.portal.aonhewitt.com';
        const OPINION_LABS_DOMAIN_MOBILE = 'http://resources.hewitt.com/mobile';


        if (this.lifecyclePhase === 'pu') {
            if (this.appUtility.getDeviceType() === 'isMobile') {
                baseDomain = OPINION_LABS_DOMAIN_MOBILE;
            } else {
                baseDomain = OPINION_LABS_DOMAIN;
            }
        } else {
            if (this.appUtility.getDeviceType() === 'isMobile') {
                baseDomain = OPINION_LABS_TEST_DOMAIN_MOBILE;
            } else {
                baseDomain = OPINION_LABS_TEST_DOMAIN;
            }
        }
        return baseDomain;
    }

    public getFeedbackRefURL() {
        let feedbackRefURL = '/${system}/${page}/${version}/${category}/${sub_category}/${portal_version}/${locale}/${clientId}/${base_ndicator}/${tech_page_name}/${friendly_page_name}';

        if (this.pageName.substring(0, 3) !== 'YSA' && this.pageName.substring(0, 7) !== 'PORTLET') {
            feedbackRefURL = feedbackRefURL.replace('${system}', 'YBR');
            feedbackRefURL = feedbackRefURL.replace('${page}', this.pageName.substring(this.pageName.indexOf('_') + 2));
            feedbackRefURL = feedbackRefURL.replace('${version}', this.version.substring(0, 4));
            feedbackRefURL = feedbackRefURL.replace('${locale}', this.locale);
            feedbackRefURL = feedbackRefURL.replace('${clientId}', this.clientId);
            feedbackRefURL = feedbackRefURL.replace('${tech_page_name}', '');
            feedbackRefURL = feedbackRefURL.replace('${friendly_page_name}', '');
            feedbackRefURL = feedbackRefURL.replace('${base_ndicator}', '');
            feedbackRefURL = feedbackRefURL.replace('${category}', this.category);
            feedbackRefURL = feedbackRefURL.replace('${sub_category}', this.subCategory);
            feedbackRefURL = feedbackRefURL.replace('${portal_version}', this.portalVersion);
        } else if (this.pageName.substring(0, 3) === 'YSA') {

            feedbackRefURL = feedbackRefURL.replace('${system}', 'YSA');
            let sPageName = '';
            if (this.pageName.indexOf('_') !== -1) {
                sPageName = this.pageName.substring(this.pageName.indexOf('_') + 1);
            } else {
                sPageName = this.pageName.substring(3);
            }
            feedbackRefURL = feedbackRefURL.replace('${page}', sPageName);
            feedbackRefURL = feedbackRefURL.replace('${version}', this.version.substring(0, 4));
            feedbackRefURL = feedbackRefURL.replace('${category}', 'YSA');
            feedbackRefURL = feedbackRefURL.replace('${sub_category}', '');
            feedbackRefURL = feedbackRefURL.replace('${locale}', this.locale);
            feedbackRefURL = feedbackRefURL.replace('${clientId}', this.clientId);
            feedbackRefURL = feedbackRefURL.replace('${portal_version}', this.portalVersion);
            feedbackRefURL = feedbackRefURL.replace('${tech_page_name}', '');
            feedbackRefURL = feedbackRefURL.replace('${friendly_page_name}', '');
            feedbackRefURL = feedbackRefURL.replace('${base_ndicator}', '');
        } else if (this.pageName.substring(0, 7) === 'PORTLET') {
            feedbackRefURL = feedbackRefURL.replace('${system}', 'PORTAL');
            feedbackRefURL = feedbackRefURL.replace('${page}', this.pageName);
            feedbackRefURL = feedbackRefURL.replace('${version}', '');
            feedbackRefURL = feedbackRefURL.replace('${locale}', this.locale);
            feedbackRefURL = feedbackRefURL.replace('${clientId}', this.clientId);
            feedbackRefURL = feedbackRefURL.replace('${portal_version}', this.portalVersion);
            feedbackRefURL = feedbackRefURL.replace('${category}', this.category);
            feedbackRefURL = feedbackRefURL.replace('${sub_category}', this.subCategory);
            feedbackRefURL = feedbackRefURL.replace('${tech_page_name}', this.title);
            feedbackRefURL = feedbackRefURL.replace('${friendly_page_name}', this.friendlyPageName);
            feedbackRefURL = feedbackRefURL.replace('${base_ndicator}', this.baseClientIndicator);

        }
        return feedbackRefURL;
    }

    initializeFeedBackUrl() {
        const OPINION_LABS_BASE_URL = 'https://secure.opinionlab.com/ccc01/comment_card.asp';
        this.feedbackUrl = OPINION_LABS_BASE_URL +
        '?referer=' + this.getBaseDomain() + this.getFeedbackRefURL()
        + '&time1=' + new Date().getTime() + '&time2=' + new Date().getTime() + '&height=' + window.screen.height + '&width='
            + window.screen.width + '&prev=' + this.prevUrl;
    }

    initializeQualtricsFeedbackUrl() {
        this.feedbackUrl = 'https://alight.az1.qualtrics.com/jfe/form/SV_0GjRjxBTmnNrN2d?Q_Language=' + this.locale.split('_')[0];
    }

      /* istanbul ignore if */
    checkBPOLightBox(event?) {
        if (event) {
            let clickedEle = (event.target || event.srcElement) as HTMLElement;
            if (clickedEle && clickedEle.nodeName !== 'A') {
                clickedEle = this.appUtility.findClosest(clickedEle, 'BY_ATTRIBUTE', 'onclick');
            }

            let getOnclickAttr: any;
            if (clickedEle && clickedEle.hasAttribute('onclick')) {
                getOnclickAttr = clickedEle.getAttribute('onclick');
                if (getOnclickAttr.indexOf('showIntranetAlert') !== -1) {
                    this._isBPOLightBox = true;
                }
            }
        }
    }
     /* istanbul ignore next */
     resizeIframe() {
        const iframe = this._element.nativeElement.querySelector('iframe') as HTMLIFrameElement;
        const extraHeight = 0;

        if (iframe) {
            let iframeDoc = iframe.contentDocument ? iframe.contentDocument : iframe.contentWindow.document;
            if (iframeDoc) {
                const body = iframeDoc.body, html = iframeDoc.documentElement;
                let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                if (height && height > 0) {
                    iframe.style.height = height + extraHeight + 'px';
                } else {
                    iframe.style.height = 150 + extraHeight + 'px';
                }
            }
        }
    }
}


